import { useEffect } from 'react';

const VIEWPORT_FIT_COVER = 'viewport-fit=cover';

/**
 * Lets the page draw under the device's safe areas (status bar, notch, home
 * indicator) by adding "viewport-fit=cover" to the viewport meta tag, so that
 * the env(safe-area-inset-*) values become available to the styles.
 * The original viewport content is restored on unmount.
 *
 * @param {boolean} enabled Whether the page should be rendered edge to edge.
 */
const useEdgeToEdgeViewport = enabled => {
  useEffect(() => {
    const viewportMeta = document.querySelector('meta[name="viewport"]');
    const originalContent = viewportMeta?.getAttribute('content');

    if (
      !enabled ||
      !viewportMeta ||
      originalContent?.includes(VIEWPORT_FIT_COVER)
    ) {
      return undefined;
    }

    viewportMeta.setAttribute(
      'content',
      originalContent
        ? `${originalContent}, ${VIEWPORT_FIT_COVER}`
        : VIEWPORT_FIT_COVER,
    );

    return () => {
      viewportMeta.setAttribute('content', originalContent ?? '');
    };
  }, [enabled]);
};

export default useEdgeToEdgeViewport;
